<template lang="pug">
.abnormal-page
  .abnormal-block
    img.error-img(src="https://m.hellobike.com/c6f55290_fd4945177e9ae9352bb4d71cd9802fc2ea667db8.png")
  .abnormal-text {{ abnormalText }}
  .reload-btn(
    v-if="buttonText"
    @click="refresh"
  ) {{ buttonText }}
</template>
<script>
export default {
  props: {
    abnormalText: {
      type: String,
      default: '加载异常，请稍后再试'
    },
    buttonText: {
      type: String,
      default: ''
    },
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    },
  }
};
</script>
<style lang="less" scoped>
.abnormal-block {
  width: 1.91rem;
  height: 1.5rem;
  margin: 1.18rem auto 0 auto;

  .error-img {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.abnormal-text {
  color: #242729;
  font-size: 0.14rem;
  font-weight: 400;
  margin: 0.16rem 0 0.16rem 0;
  text-align: center;
}

.reload-btn {
  width: 0.8rem;
  height: 0.32rem;
  line-height: 0.32rem;
  border-radius: 0.16rem;
  background: #08f;
  color: #fff;
  text-align: center;
  font-size: 0.14rem;
  font-weight: 500;
  margin: 0 auto;
}
</style>
